import { render, staticRenderFns } from "./longTimeField.vue?vue&type=template&id=3960c081&scoped=true"
import script from "./longTimeField.vue?vue&type=script&lang=js"
export * from "./longTimeField.vue?vue&type=script&lang=js"
import style0 from "./longTimeField.vue?vue&type=style&index=0&id=3960c081&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3960c081",
  null
  
)

export default component.exports